export class Transportation {
    transportationExplanation?: string;
    smallMileageAllowance?: boolean;
    largeMileageAllowance?: boolean;
    largeMileageAllowanceExplanation?: string;
    isPrivateTrip?: boolean;

    transportationTrain?: boolean;
    transportationReservation?: boolean;
    transportationPublicTransport?: boolean;
    transportationMotorcycle?: boolean;
    transportationBicycle?: boolean;
    transportationAirplane?: boolean;
    transportationRentalCar?: boolean;
    transportationLongDistanceBus?: boolean;
    transportationOther?: boolean;
    transportationCompanyCar?: boolean;
    transportationOwnCar?: boolean;

    transportationReservationExplanation?: string;
    transportationOtherExplanation?: string;

    privateTripBeginDate?: Date;
    privateTripEndDate?: Date;
    privateTripResidence?: string;
    privateTripAddress?: string;
    privateTripExplanation?: string;
}

